var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBonuse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.948291,
    y: 4.88743,
    width: 13.9382,
    height: 10.4126,
    rx: 2.8,
    stroke: "#1890FF",
    strokeWidth: 1.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.55308 2.01278C8.51612 1.55654 8.2826 1.2049 8.00003 1.2049C7.69178 1.2049 7.44189 1.62338 7.44189 2.13961V14.7804L7.44699 14.9072C7.48395 15.3635 7.71747 15.7151 8.00003 15.7151C8.30829 15.7151 8.55817 15.2966 8.55817 14.7804V2.13961L8.55308 2.01278Z",
    fill: "#1890FF",
    stroke: "#1890FF",
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02227 2.71499C8.02227 1.60214 8.92441 0.7 10.0373 0.7C11.1501 0.7 12.0522 1.60214 12.0522 2.71499V2.77307C12.0522 3.91799 11.1241 4.84614 9.97917 4.84614H8.02227V2.71499Z",
    stroke: "#1890FF",
    strokeWidth: 1.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.97529 2.71499C7.97529 1.60214 7.07315 0.7 5.9603 0.7C4.84746 0.7 3.94531 1.60214 3.94531 2.71499V2.77307C3.94531 3.91799 4.87346 4.84614 6.01839 4.84614H7.97529V2.71499Z",
    stroke: "#1890FF",
    strokeWidth: 1.4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonuse);
export default __webpack_public_path__ + "static/media/bonuse.546c77f1a7033629059134882e0138ed.svg";
export { ForwardRef as ReactComponent };